import Raven from 'raven-js';
import { addSuccess, addAlert
// @ts-expect-error file is untyped
} from 'customer-data-ui-utilities/alerts/Alerts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { trackSingleEnrollError } from 'sequences-lib/lib/CustomPageActions';
import { CRM } from 'sequences-lib/constants/Platform';
import { Metrics } from 'customer-data-objects/metrics/Metrics';
import { SEQUENCE_ENROLL_ERROR } from 'crm-activity-creator-data/constants/errors';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const SEND_TIME_TOO_FAR_IN_PAST = 'SequenceError.SEQUENCE_SEND_TIME_TOO_FAR_IN_PAST';
const microsoftDateTimeSettings = 'https://support.microsoft.com/en-us/help/4026213/windows-how-to-set-your-time-and-time-zone';
const appleDateTimeSettings = 'https://support.apple.com/en-us/HT203413';
export const handleEnrollSequenceSuccess = ({
  completedEnrollment,
  sequenceName
}) => {
  addSuccess('createActivityButtons.sequences.successMessage', {
    email: completedEnrollment.get('toEmail'),
    sequenceName
  }, {
    ['data-selenium-test']: 'sequence-enrollment-alert'
  });
};
export const handleEnrollSequenceFailure = ({
  err
}) => {
  if (err.responseJSON && err.responseJSON.errorType === SEND_TIME_TOO_FAR_IN_PAST) {
    addAlert({
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createActivityButtons.sequences.enrollError.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "createActivityButtons.sequences.tooFarInPastErrorMessage_jsx",
        options: {
          microsoftHref: microsoftDateTimeSettings,
          appleHref: appleDateTimeSettings
        },
        elements: {
          AppleSettingsLink: Link,
          MicrosoftSettingsLink: Link
        }
      }),
      type: 'danger'
    });
    Raven.captureMessage('Sequence enroll error first step in past', {
      fingerprint: ['ERROR_SEQUENCE_ENROLL_ERROR_FIRST_STEP_IN_PAST'],
      extra: {
        statusCode: err.status,
        responseText: err.responseText
      }
    });
  } else {
    addAlert({
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createActivityButtons.sequences.enrollError.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createActivityButtons.sequences.enrollError.message"
      }),
      type: 'danger'
    });
    Metrics.counter(SEQUENCE_ENROLL_ERROR, {
      statusCode: `${err.status}`,
      errorType: err.responseJSON.errorType,
      message: err.responseText
    }).increment();
  }
  trackSingleEnrollError(CRM, err);
};